module.exports = __webpack_public_path__ + "static/media/9.8762fdec.JPG";